import type { BlogPostSummary } from "./blog";

// Split out of ./blog so components that only need "is this post visible yet"
// (e.g. BlogPostCard, reused on the home page) don't have to import ./blog's
// yaml + eager glob of every locale's Markdown just for this pure check.

function todayIsoUtc(now: Date): string {
  return now.toISOString().slice(0, 10);
}

export function isScheduledPost(
  post: Pick<BlogPostSummary, "published" | "publishedAt">,
  now = new Date(),
): boolean {
  return post.published && post.publishedAt > todayIsoUtc(now);
}

export function isPublicPost(
  post: Pick<BlogPostSummary, "published" | "publishedAt">,
  now = new Date(),
): boolean {
  return post.published && !isScheduledPost(post, now);
}
